import { useEffect, useState } from "react";
import api from "@/lib/api";
import { optimizeImage } from "@/lib/mediaUrls";

const fmt = (iso) => {
  const d = new Date(iso);
  return Number.isFinite(d.getTime())
    ? d.toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" })
    : "";
};

// Host/admin-only attendee list — name, photo and RSVP time only.
export const EventAttendeesList = ({ eventId, refreshKey }) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api.get(`/live/events/${eventId}/rsvps`)
      .then((r) => { if (!cancelled) setData(r.data); })
      .catch((e) => { if (!cancelled) setError(e.response?.data?.detail || "Could not load attendees"); });
    return () => { cancelled = true; };
  }, [eventId, refreshKey]);

  if (error) return <p className="text-sm text-red-300" data-testid="attendees-error">{error}</p>;
  if (!data) return <p className="text-sm text-gray-400" data-testid="attendees-loading">Loading attendees…</p>;

  return (
    <div data-testid="attendees-list">
      <p className="text-sm text-gray-300 mb-3" data-testid="attendees-total">
        <span className="text-white font-bold">{data.count}</span> {data.count === 1 ? "registration" : "registrations"}
      </p>
      {data.count === 0 ? (
        <p className="text-sm text-gray-500" data-testid="attendees-empty">No one has reserved a spot yet.</p>
      ) : (
        <ul className="space-y-2 max-h-80 overflow-y-auto pr-1">
          {data.attendees.map((a) => (
            <li key={a.user_id} className="flex items-center gap-3" data-testid={`attendee-${a.user_id}`}>
              {a.profile_photo ? (
                <img src={optimizeImage(a.profile_photo, 'avatar')} alt="" className="w-9 h-9 rounded-full object-cover border border-purple-500/40" />
              ) : (
                <div className="w-9 h-9 rounded-full bg-purple-800/60 flex items-center justify-center text-white text-sm font-bold">
                  {(a.name || "?").charAt(0).toUpperCase()}
                </div>
              )}
              <div className="min-w-0 flex-1">
                <p className="text-sm text-white truncate">{a.name}</p>
                <p className="text-[11px] text-gray-500">Reserved {fmt(a.rsvp_at)}</p>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default EventAttendeesList;
